module.exports = __webpack_public_path__ + "img/twitter.88f927a8.svg";